export default [
    {
        path: '/supervision/supervision',
        name: 'supervision',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/supervision/Supervision.vue')
    }
]